import './video-cta.component.scss'

document.querySelectorAll('.video-cta-media').forEach((root) => {
  const video = root.querySelector('video')
  const play = root.querySelector('.video-cta-media__play')
  video.addEventListener('pause', () => {
    root.classList.remove('is-play')
    play.textContent = 'play'
  })
  video.addEventListener('play', () => {
    root.classList.add('is-play')
    play.textContent = 'pause'
  })
  root.addEventListener('click', async () => {
    if (video.paused) {
      await video.play()
    } else {
      video.pause()
    }
  })
})
